import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './productModal.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';


function ProductModal({ producto, onClose }) {

  const [tab, setTab] = useState('caracteristicas');
  const navigate = useNavigate();

  console.log('PRODUCTO ACTIVO:', producto);

  if (!producto) return null;

const irCotizar = () => {
  if (producto.tipo === 'caja') {
    window.open('https://corrugadosderisaralda.com/', '_blank');
  } else {
    navigate('/contacto'); // 🔥 CORRECTO
  }
};

  return (
    <div className="modal-overlay" onClick={onClose}>
      
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        
        <button className="modal-close" onClick={onClose}>×</button>

        <div className="modal-content">

          {/* IZQUIERDA */}
          <div className="modal-left">
            <Swiper spaceBetween={10} slidesPerView={1}>
              {(producto.imagenes || [producto.imagen]).map((img, i) => (
                <SwiperSlide key={i}>
                  <img src={img} alt="" className="modal-img" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* DERECHA */}
          <div className="modal-right">

            <h2>{producto.titulo}</h2>

            <p className="modal-desc">{producto.descripcion}</p>

            <div className="tabs">
              <button 
                className={tab === 'caracteristicas' ? 'active' : ''}
                onClick={() => setTab('caracteristicas')}
              >
                Características
              </button>

              <button 
                className={tab === 'usos' ? 'active' : ''}
                onClick={() => setTab('usos')}
              >
                Usos
              </button>

              <button 
                className={tab === 'especificaciones' ? 'active' : ''}
                onClick={() => setTab('especificaciones')}
              >
                Especificaciones
              </button>
            </div>

            <div className="tab-content">

              {tab === 'caracteristicas' && (
                <div>
                  {producto.caracteristicas?.map((c, i) => (
                    <p key={i}>
                      <strong>{c.titulo}:</strong> {c.valor}
                    </p>
                  ))}
                </div>
              )}

              {tab === 'usos' && (
                <ul>
                  {producto.usos?.map((u, i) => (
                    <li key={i}>{u}</li>
                  ))}
                </ul>
              )}

              {/* 🔥 AQUÍ ESTABA EL ERROR */}
              {tab === 'especificaciones' && producto.fichaTecnica && (
                <div className="tabla-wrapper">
                  
                  <table className="tabla-tecnica">
                    <thead>
                      <tr>
                        {producto.fichaTecnica.headers.map((h, i) => (
                          <th key={i}>{h}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {producto.fichaTecnica.rows.map((row, i) => {
                        return row.valores.map((rango, j) => {
                          return (
                            <tr key={i + '-' + j}>

                              {j === 0 && (
                                <>
                                  <td rowSpan={row.valores.length}>{row.propiedad}</td>
                                  <td rowSpan={row.valores.length}>{row.metodo}</td>
                                </>
                              )}

                              <td className="col-rango">{rango[0]}</td>

                              {rango.slice(1).map((v, k) => (
                                <td key={k}>{v}</td>
                              ))}

                            </tr>
                          );
                        });
                      })}
                    </tbody>
                  </table>

                </div>
              )}

              {/* 🔥 MENSAJE DEL JEFE */}
              <div className="extra-info">
                <p>
                  Estas fichas técnicas son estándar.<br />
                  <strong>Contáctanos para diseñar la tuya a tu medida.</strong>
                </p>
              </div>

            </div>

            <div className="modal-actions">
              <button className="btn-primary" onClick={irCotizar}>
                Cotizar
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default ProductModal;